import {useEffect, useMemo, useState} from "react";
import {Button, Menu, MenuItem, Typography} from "@mui/material";

export const GranularityPicker = ({granularitySetter, filters}) => {
    const options = useMemo(() => ['Q', 'M', 'D'], []);
    const optionNames = useMemo(() => ['Quarter', 'Month', 'Day'], []);
    const [anchorElement, setAnchorElement] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(options.indexOf(filters.granularity));

    useEffect(() => {
        if (filters.granularity !== options[selectedIndex]) {
            setSelectedIndex(options.indexOf(filters.granularity));
        }
    }, [filters, selectedIndex, options]);

    const handleClick = (event) => {
        setAnchorElement(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        setAnchorElement(null);
        setSelectedIndex(index);
        granularitySetter(options[index]);
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    return (
        <div>
            <Typography variant="h7" display="inline">Granularity:</Typography>
            <Button onClick={handleClick}>{optionNames[selectedIndex]}</Button>
            <Menu id="PickerMenu" anchorEl={anchorElement} keepMounted open={Boolean(anchorElement)}
                  onClose={handleClose}>
                {options.map((o, index) => (
                    <MenuItem key={o} value={o} selected={selectedIndex === index}
                              onClick={(event) => handleMenuItemClick(event, index)}>{optionNames[index]}</MenuItem>
                ))}
            </Menu>
        </div>
    );
};